import type {
    LogoutResponse,
    PartnerReferrersResponse,
    RolesAndPermissionsResponse,
} from '~/types/api';
import httpRequest from '~/utils/httpRequest';

export const getRolesAndPermissions =
    async (): Promise<RolesAndPermissionsResponse> => {
        const res = await httpRequest.get<RolesAndPermissionsResponse>(
            '/api/getRolesAndPermissions',
        );
        return res.data;
    };

export const logout = async (): Promise<LogoutResponse> => {
    const res = await httpRequest.post<LogoutResponse>('/api/logout');
    return res.data;
};

export const getPartnerReferrers =
    async (): Promise<PartnerReferrersResponse> => {
        const res = await httpRequest.get<PartnerReferrersResponse>(
            '/api/getPartnerReferrer',
        );
        return res.data;
    };
